import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			rx: 9,
			fill: "#FF7B74"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 4,
			width: 2,
			height: 6,
			rx: 1,
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.5,
			y: 11,
			width: 3,
			height: 3,
			rx: 1.5,
			fill: "#002E5F"
		})
	]
});
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
